export const BIRTHDAY_DATE = '1999/02/19';
export const EXPERIENCE_DATE = '2020/06/01';

export const textPattern = '^[^<>!#$%^*:;",.=+\\]\\[\\}\\{]+$';

export const PAGES_LINK = {
  home: '#Home',
  about: '#About',
  technologies: '#Technologies',
  projects: '#Projects',
  contact: '#Contact'
};
